import api from "@/lib/api";
import { toast } from "sonner";

// SETTING A TRUCK'S VEHICLE TYPE — in one place, because two screens do it.
//
// What it costs, said as it happens: the server rebuilds the truck's search index against the
// NEW type's fields and LEAVES every recorded value in place. So a value whose field the new
// type doesn't define stays in the database and stops being displayed by the spec panel, found
// by search, and counted in the completeness figure. Kept, invisible. That is a normal
// consequence of a normal action, so it is named at the moment of the change rather than left
// as a trail to discover later. The fleet-wide list lives on Health & Integrity.
export async function setDonorCategory(donorId, code) {
  const { data } = await api.post(`/donors/${donorId}/category`, { category: code });
  const orphaned = data.orphaned_specs || [];
  if (orphaned.length) {
    toast.warning(
      `Category set — but ${orphaned.length} recorded value${orphaned.length === 1 ? "" : "s"} ` +
      `belong${orphaned.length === 1 ? "s" : ""} to a field this vehicle type doesn't define: ` +
      orphaned.map((o) => `${o.label} = ${o.value}`).join(" · ") +
      `. Still on the record, but from now on ${orphaned.length === 1 ? "it won't" : "they won't"} ` +
      "show on this panel, won't be searchable and won't count towards capture. " +
      "Health & Integrity lists them.",
      { duration: 16000 },
    );
  } else {
    toast.success("Category set");
  }
  return data;
}
